import axios from "axios";
import config from "../../settings/config";
import { handleError } from "../../network/servicErrorHandling";

const authAxiosInstance = axios.create();

async function login(phone, mode) {
  return Promise.resolve().then((v) =>
    authAxiosInstance
      .post(
        config.baseUrl + `v1/${mode ? mode : "clients"}/auth`,
        {
          phone: phone,
          token: config.token,
        },
        {
          headers: {},
        }
      )
      .then((res) => {
        const loginRes = {
          data: res.data,
          status: res.status,
        };
        return loginRes;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

async function confirm(code, token, mode) {
  return Promise.resolve().then((v) =>
    authAxiosInstance
      .post(
        config.baseUrl + `v1/${mode ? mode : "clients"}/auth/verification`,
        {
          code: code,
          token: token,
        },
        {
          headers: {},
        }
      )
      .then((res) => {
        return res;
      })
      .catch((err) => {
        handleError(err);
        return err;
      })
  );
}

export { login, confirm };
